import { http, HttpResponse, HttpHandler } from 'msw';

import { FeatureFlags } from '../../../domain/config';
import { featureFlags } from '../../domain-helper';

type Options = {
  once?: boolean;
};

const createFeatureFlagsHandler = (overrides?: Partial<FeatureFlags>, options?: Options) =>
  http.get<never, never, FeatureFlags>(
    '/qualification/config/features',
    () => {
      const jsonResponse = featureFlags(overrides);
      return HttpResponse.json(jsonResponse);
    },
    {
      once: options?.once,
    },
  );

const handlers: HttpHandler[] = [createFeatureFlagsHandler()];

export { handlers, createFeatureFlagsHandler };
